import { useEffect, useState } from 'react';

export const useNumberCounter = (targetNumber: number, duration: number): number => {
	const [count, setCount] = useState(0);

	useEffect(() => {
		let startTimestamp: number | undefined;
		let animationFrameId: number;

		const startCountAnimation = (timestamp: number) => {
			if (!startTimestamp) startTimestamp = timestamp;
			const progress = timestamp - startTimestamp;
			const percentage = Math.min(progress / duration, 1);
			const nextCount = Math.floor(percentage * targetNumber);
			setCount(nextCount);

			if (progress < duration) {
				animationFrameId = requestAnimationFrame(startCountAnimation);
			}
		};

		animationFrameId = requestAnimationFrame(startCountAnimation);

		return () => cancelAnimationFrame(animationFrameId);
	}, [targetNumber, duration]);

	return count;
};
